/* eslint-disable global-require */

import Vue from 'vue';
import _ from 'lodash';
import VueRouter from 'vue-router';
// The platform store loads the API lazily inside actions, after initialization.
// eslint-disable-next-line import/no-cycle
import store from '../store';

import IndeegoError from '../views/IndeegoError.vue';

import Login from '../views/Login.vue';
import Sso from '../views/Sso.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import InitPassword from '../views/InitPassword.vue';
import InitAccount from '../views/InitAccount.vue';
import Home from '../views/Home.vue';
import Inbox from '../views/Inbox.vue';
import InboxRecurrentInterventions from '../views/inbox/RecurrentInterventions.vue';
import InboxOnline from '../views/inbox/Online.vue';
import Interventions from '../views/Interventions.vue';
import Planning from '../views/Planning.vue';
import Equipments from '../views/Equipments.vue';
import Statistics from '../views/Statistics.vue';
import NewTicket from '../views/NewTicket.vue';

import MyAccount from '../views/MyAccount.vue';
import MyAccountInfos from '../views/myAccount/Infos.vue';
import MyAccountPassword from '../views/myAccount/Password.vue';
import MyAccountNotifications from '../views/myAccount/Notifications.vue';

import Settings from '../views/settings/Index.vue';
import SettingsGeneral from '../views/settings/General.vue';
import SettingsStatuses from '../views/settings/Statuses.vue';
import SettingsPriorities from '../views/settings/Priorities.vue';
import SettingsDomains from '../views/settings/Domains.vue';
import SettingsTags from '../views/settings/Tags.vue';
import SettingsUsers from '../views/settings/Users.vue';
import SettingsSites from '../views/settings/Sites.vue';
import SettingsRecurrentInterventions from '../views/settings/RecurrentInterventions.vue';
import SettingsClients from '../views/settings/clients/Index.vue';
import SettingsClientsList from '../views/settings/clients/List.vue';
import SettingsClient from '../views/settings/clients/Client.vue';
import SettingsClientInfos from '../views/settings/clients/Infos.vue';
import SettingsClientSites from '../views/settings/clients/Sites.vue';
import SettingsClientUsers from '../views/settings/clients/Users.vue';
import SettingsClientRecurrentInterventions from '../views/settings/clients/RecurrentInterventions.vue';
import SettingsClientEquipments from '../views/settings/clients/Equipments.vue';
import SettingsClientMaintenanceContracts from '../views/settings/clients/MaintenanceContracts.vue';
import SettingsMakers from '../views/settings/makers/Index.vue';
import SettingsMakersList from '../views/settings/makers/List.vue';
import SettingsMaker from '../views/settings/makers/Maker.vue';
import SettingsMakerInfos from '../views/settings/makers/Infos.vue';
import SettingsMakerStatuses from '../views/settings/makers/Statuses.vue';
import SettingsMakerPriorities from '../views/settings/makers/Priorities.vue';
import SettingsMakerDomains from '../views/settings/makers/Domains.vue';
import SettingsMakerUsers from '../views/settings/makers/Users.vue';

import IndeegoSettings from '../views/indeegoSettings/Index.vue';
import IndeegoSettingsClients from '../views/indeegoSettings/Clients.vue';
import IndeegoSettingsReportPdfCache from '../views/indeegoSettings/ReportPdfCache.vue';
import IndeegoSettingsShutdown from '../views/indeegoSettings/Shutdown.vue';
import IndeegoSettingsUsers from '../views/indeegoSettings/Users.vue';
import IndeegoSettingsUserVisits from '../views/indeegoSettings/UserVisits.vue';
import IndeegoSettingsLogs from '../views/indeegoSettings/Logs.vue';

Vue.use(VueRouter);

const routes = [
  {
    // Literal import paths avoid the legacy Babel/ESLint template token crash.
    // eslint-disable-next-line quotes
    path: `/data-exports`, name: `dataExports`, component: () => import('../views/DataExports.vue'), meta: { title: `Export des données` },
  },
  {
    path: `/indeego-error`,
    name: `indeegoError`,
    component: IndeegoError,
    meta: { layout: `none` },
  },
  {
    path: `/`,
    name: `home`,
    component: Home,
    meta: { layout: `none` },
  },
  {
    path: `/login`,
    name: `login`,
    component: Login,
    meta: { layout: `Auth`, title: `Connexion` },
  },
  {
    path: `/logout`,
    name: `logout`,
    component: Login,
    meta: { layout: `Auth`, title: `Déconnexion` },
  },
  {
    path: `/sso`,
    name: `sso`,
    component: Sso,
    meta: { layout: `Auth`, title: `Connexion` },
  },
  {
    path: `/forgot-password`,
    name: `forgotPassword`,
    component: ForgotPassword,
    meta: { layout: `Auth`, title: `Mot de passe oublié` },
  },
  {
    path: `/init-password`,
    name: `initPassword`,
    component: InitPassword,
    meta: { layout: `Auth`, title: `Nouveau mot de passe` },
  },
  {
    path: `/init-account`,
    name: `initAccount`,
    component: InitAccount,
    meta: { layout: `InitAccount`, title: `Initialisation de compte` },
  },
  {
    path: `/inbox`,
    name: `inbox`,
    component: Inbox,
    meta: { title: `Inbox` },
    children: [
      {
        path: `recurrent-interventions`,
        name: `inboxRecurrentInterventions`,
        component: InboxRecurrentInterventions,
      },
      {
        path: `online`,
        name: `inboxOnline`,
        component: InboxOnline,
      },
    ],
  },
  {
    path: `/interventions`,
    name: `interventions`,
    component: Interventions,
    meta: { title: `Interventions` },
    children: [
      {
        path: `challenging/:challengingInterventionId`,
        name: `InterventionsChallengingIntervention`,
        component: Interventions,
      },
      {
        path: `:interventionId`,
        name: `InterventionsIntervention`,
        component: Interventions,
        children: [
          {
            path: `change-status`,
            name: `InterventionsInterventionChangeStatus`,
            component: Interventions,
          },
          {
            path: `add-comment`,
            name: `InterventionsInterventionAddComment`,
            component: Interventions,
          },
          {
            path: `change-assignee`,
            name: `InterventionsInterventionChangeAssignee`,
            component: Interventions,
          },
          {
            path: `add-attachment`,
            name: `InterventionsInterventionAddAttachment`,
            component: Interventions,
          },
          {
            path: `add-estimate-or-invoice`,
            name: `InterventionsInterventionAddEstimateOrInvoice`,
            component: Interventions,
          },
        ],
      },
    ],
  },
  {
    path: `/tickets/new`,
    name: `newTicket`,
    component: NewTicket,
    meta: { title: `Nouvelle intervention` },
  },
  {
    path: `/planning`,
    name: `planning`,
    component: Planning,
    meta: { title: `Planning` },
  },
  {
    path: `/equipments`,
    name: `equipments`,
    component: Equipments,
    meta: { title: `Équipements` },
  },
  {
    path: `/statistics`,
    name: `statistics`,
    component: Statistics,
    meta: { title: `Statistiques` },
  },
  {
    path: `/my-account`,
    name: `myAccount`,
    component: MyAccount,
    meta: { title: `Mon compte` },
    children: [
      {
        path: `infos`,
        name: `myAccount.infos`,
        component: MyAccountInfos,
        meta: { title: `Mes infos` },
      },
      {
        path: `password`,
        name: `myAccount.password`,
        component: MyAccountPassword,
        meta: { title: `Mon mot de passe` },
      },
      {
        path: `notifications`,
        name: `myAccount.notifications`,
        component: MyAccountNotifications,
        meta: { title: `Notifications` },
      },
    ],
  },
  {
    path: `/settings`,
    name: `settings`,
    component: Settings,
    meta: { title: `Administration` },
    children: [
      {
        path: `general`,
        name: `settings.general`,
        component: SettingsGeneral,
        meta: { title: `Général` },
      },
      {
        path: `statuses`,
        name: `settings.statuses`,
        component: SettingsStatuses,
        meta: { title: `Status` },
      },
      {
        path: `priorities`,
        name: `settings.priorities`,
        component: SettingsPriorities,
        meta: { title: `Priorités` },
      },
      {
        path: `domains`,
        name: `settings.domains`,
        component: SettingsDomains,
        meta: { title: `Domaines` },
      },
      {
        path: `tags`,
        name: `settings.tags`,
        component: SettingsTags,
        meta: { title: `Tags` },
      },
      {
        path: `users`,
        name: `settings.users`,
        component: SettingsUsers,
        meta: { title: `Utilisateurs` },
      },
      {
        path: `sites`,
        name: `settings.sites`,
        component: SettingsSites,
        meta: { title: `Sites` },
      },
      {
        path: `recurrent-interventions`,
        name: `settings.recurrentInterventions`,
        component: SettingsRecurrentInterventions,
        meta: { title: `Interventions récurrentes` },
      },
      {
        path: `clients`,
        name: `settings.clients`,
        component: SettingsClients,
        meta: { title: `Clients` },
        children: [
          {
            path: ``,
            component: SettingsClientsList,
          },
          {
            path: `:clientId`,
            name: `settings.client`,
            component: SettingsClient,
            meta: { title: `Client` },
            children: [
              {
                path: ``,
                redirect(to) {
                  return `/settings/clients/${to.params.clientId}/infos`;
                },
              },
              {
                path: `infos`,
                name: `settings.client.infos`,
                component: SettingsClientInfos,
              },
              {
                path: `sites`,
                name: `settings.client.sites`,
                component: SettingsClientSites,
                meta: { title: `Sites` },
              },
              {
                path: `users`,
                name: `settings.client.users`,
                component: SettingsClientUsers,
                meta: { title: `Utilisateurs` },
              },
              {
                path: `recurrent-interventions`,
                name: `settings.client.recurrentInterventions`,
                component: SettingsClientRecurrentInterventions,
                meta: { title: `Interventions récurrentes` },
              },
              {
                path: `equipments`,
                name: `settings.client.equipments`,
                component: SettingsClientEquipments,
                meta: { title: `Équipements` },
              },
              {
                path: `maintenance-contracts`,
                name: `settings.client.maintenanceContracts`,
                component: SettingsClientMaintenanceContracts,
                meta: { title: `Contrats de maintenance` },
              },
            ],
          },
        ],
      },
      {
        path: `makers`,
        name: `settings.makers`,
        component: SettingsMakers,
        meta: { title: `Prestataires` },
        children: [
          {
            path: ``,
            component: SettingsMakersList,
          },
          {
            path: `:makerId`,
            name: `settings.maker`,
            component: SettingsMaker,
            meta: { title: `Prestataire` },
            children: [
              {
                path: ``,
                redirect(to) {
                  return `/settings/makers/${to.params.makerId}/infos`;
                },
              },
              {
                path: `infos`,
                name: `settings.maker.infos`,
                component: SettingsMakerInfos,
              },
              {
                path: `statuses`,
                name: `settings.maker.statuses`,
                component: SettingsMakerStatuses,
              },
              {
                path: `priorities`,
                name: `settings.maker.priorities`,
                component: SettingsMakerPriorities,
              },
              {
                path: `domains`,
                name: `settings.maker.domains`,
                component: SettingsMakerDomains,
              },
              {
                path: `users`,
                name: `settings.maker.users`,
                component: SettingsMakerUsers,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: `/indeego-settings`,
    name: `indeegoSettings`,
    component: IndeegoSettings,
    meta: { title: `Administration Indeego` },
    children: [
      {
        path: `clients`,
        name: `indeegoSettings.clients`,
        component: IndeegoSettingsClients,
        meta: { layout: `IndeegoSettings`, title: `Clients` },
      },
      {
        path: `report-pdf-cache`,
        name: `indeegoSettings.reportPdfCache`,
        component: IndeegoSettingsReportPdfCache,
        meta: { layout: `IndeegoSettings`, title: `Cache PDFs CR` },
      },
      {
        path: `shutdown`,
        name: `indeegoSettings.shutdown`,
        component: IndeegoSettingsShutdown,
        meta: { layout: `IndeegoSettings`, title: `Shutdown` },
      },
      {
        path: `users`,
        name: `indeegoSettings.users`,
        component: IndeegoSettingsUsers,
        meta: { layout: `IndeegoSettings`, title: `Utilisateurs` },
      },
      {
        path: `user-visits`,
        name: `indeegoSettings.userVisits`,
        component: IndeegoSettingsUserVisits,
        meta: { layout: `IndeegoSettings`, title: `Visites utilisateurs` },
      },
      {
        path: `logs`,
        name: `indeegoSettings.logs`,
        component: IndeegoSettingsLogs,
        meta: { layout: `IndeegoSettings`, title: `Logs` },
      },
    ],
  },
  {
    path: `/workload`,
    name: `workload`,
    component: require(`../views/Workload.vue`).default,
  },
];

const router = new VueRouter({
  mode: `history`,
  base: process.env.BASE_URL,
  routes,
});

const AUTH_ROUTES = [`/login`, `/forgot-password`, `/init-password`, `init-account`];

router.beforeEach(async (to, from, next) => {
  if (to.name === `login` && store.state[`ui/login`].originPath === `/data-exports` && to.query.redirect !== `/data-exports`) {
    return next({ name: `login`, query: { ...to.query, redirect: `/data-exports` }, replace: true });
  }
  if (to.name === `newTicket`) {
    await store.dispatch(`platform/refresh`);
    if (!store.getters[`platform/canWrite`]) return next({ name: `interventions` });
  }
  if (to.name === `dataExports`) {
    store.dispatch(`ui/login/saveOriginPath`, `/data-exports`);
    try {
      await Promise.all([store.dispatch(`model/user/fetchMe`), store.dispatch(`model/client/fetchCompany`)]);
      const { me } = store.state[`model/user`];
      const { company } = store.state[`model/client`];
      if (!me) return next({ name: `login`, query: { redirect: `/data-exports` } });
      store.dispatch(`ui/login/saveOriginPath`, `/`);
      if (!company || me.role !== `administrator` || me.Client_id !== company.id || !company.slug) return next({ name: `home` });
    } catch (e) { return next({ name: `login`, query: { redirect: `/data-exports` } }); }
  }
  // if (to.path !== `/indeego-error`
  //   && window.location.host.indexOf(`.indeego.fr`) !== -1
  //   && window.location.host.indexOf(`bezagu.indeego.fr`) === -1
  //   && window.location.host.indexOf(`.demo.indeego.fr`) === -1
  // ) {
  //   return next(`/indeego-error`);
  // }

  // if (to.path === `/indeego-error`
  //   && (
  //     window.location.host.indexOf(`.indeego.fr`) === -1
  //     || window.location.host.indexOf(`.demo.indeego.fr`) !== -1
  //     || window.location.host.indexOf(`bezagu.indeego.fr`) !== -1
  //   )
  // ) {
  //   return next(`/`);
  // }

  if (to.path === `/indeego-error`) {
    return next(`/`);
  }

  if (to.path.startsWith(`/v3`)) {
    return next(to.path.replace(/^\/v3/, ``));
  }

  if (!to.matched.length) {
    return next({ name: `home` });
  }

  const destCanRedirect = to.path.startsWith(`/login`) || to.path.startsWith(`/init-account`);
  const isAuthRoute = _.includes(AUTH_ROUTES, to.path);

  if (!store.state[`ui/mainLayout`].slug) {
    store.dispatch(`ui/mainLayout/loadUrlInfos`);
  }
  const { slug } = store.state[`ui/mainLayout`];
  const isIndeegoAdminApp = slug === `admin`;
  const isIndeegoSettings = to.path.startsWith(`/indeego-settings`);
  const isMyAccount = to.name === `myAccount`;

  if (!isIndeegoAdminApp && isIndeegoSettings) {
    return next({ name: `home` });
  }

  if (isIndeegoAdminApp && !isAuthRoute && !isIndeegoSettings && !isMyAccount) {
    return next({ name: `indeegoSettings` });
  }

  if (destCanRedirect && !isAuthRoute) {
    store.dispatch(`ui/login/saveOriginPath`, from.path);
  }

  const title = _.chain(to.matched)
    .filter(r => Boolean(r.meta?.title))
    .map(r => r.meta.title)
    .unshift(`Indeego`)
    .join(` - `)
    .value();

  window.document.title = title;

  store.commit(`ui/mainLayout/SET_ROUTER_TITLE`, title);

  return next();
});

export default router;
